import { lift } from 's-array';
import { TZUtils } from 'lib/tzutils';

import { PortCall } from 'data/models/PortCall';
import { ScheduleDateEntity } from 'data/models/ScheduleDateEntity';

export interface PortCallScheduleHeaderParams {
    PortCall : PortCall;
}

export type PortCallScheduleHeader = ReturnType<typeof PortCallScheduleHeader>;
export function PortCallScheduleHeader(
    tzutils : TZUtils,
    { PortCall } : PortCallScheduleHeaderParams
) {
    const milestones = lift(() => PortCall.MilestoneDates())
        .map(ScheduleHeaderMilestoneDate);

    return {
        TZUtils: tzutils,
        PortCall,
        FirstMilestone: () => milestones().length ? milestones()[0] : null,
        LastMilestone: () => milestones().length ? milestones()[milestones().length - 1] : null
    };
}

export type ScheduleHeaderMilestoneDate = ReturnType<typeof ScheduleHeaderMilestoneDate>;
function ScheduleHeaderMilestoneDate(Date : ScheduleDateEntity) {
    return { Date };
}



// WEBPACK FOOTER //
// ./apps/portcall/portcallschedule/header.ts